/**
 * @module Sagas/Card
 * @desc Card
 */

import { put, call } from 'redux-saga/effects';
import { getAllCategoriesSuccess, getAllCategoriesFailure, showAlert } from 'actions/index';

export function* getAllCategoriesRequest(api, action) {
  const { status, data } = yield call(api.getAllCategoriesRequest, action.payload);
  if (status === 200) {
    yield put(getAllCategoriesSuccess(data.data));
  } else {
    const msg = data?.error?.message;
    const isArray = Array.isArray(msg);
    const isString = typeof msg === 'string';
    const display = isArray ? msg.join(', ') : isString ? msg : 'Failed to load categories';
    yield put(showAlert(display, { variant: 'danger' }));
    yield put(getAllCategoriesFailure());
  }
}
